import React, {useEffect, useState} from 'react';
import * as securityHelper from "../helper/SecurityHelper";
export default function DashBoard() {
    const [userName, setUserName] = useState(false);
    // TODO : 임시
    useEffect(() => {
        var user = securityHelper.getLoginUser()
        setUserName(user?.name)
    })
  return (
    <div>
      dashboard {userName}
        <br/>
        <button onClick={securityHelper.logout}>로그아웃</button>
    </div>
  );
}

